/**
 * Profile global JS.
 */

import domContentLoaded from 'utils/domContentLoaded';
import reactComponentManager from 'utils/reactComponentManager';

// Components
import LoadMore from 'components/load-more';
import NBCTruncate from 'components/nbc-truncate';

// Import SCSS
import '../../scss/profile/index.scss';

// read more on profile bio
const bio = document.querySelector('.article-content');
const readMore = document.querySelector('.profile-content-toggle');
const readMoreOpen = nbc.brand && 'nbc' === nbc.brand ? 'Read more' : 'Ver más';
const readMoreClose = nbc.brand && 'nbc' === nbc.brand ? 'Read less' : 'Ver menos';

function detectOverflow() {
  return bio.scrollHeight > bio.clientHeight;
}

function displayReadMore() {
  readMore.innerText = readMoreOpen;
  readMore.style.display = 'block';

  readMore.addEventListener('click', () => {
    bio.style.cssText = readMoreOpen === readMore.innerText ? '-webkit-line-clamp: unset; display:block;' : '';
    readMore.innerText = readMoreOpen === readMore.innerText ? readMoreClose : readMoreOpen;
  });
}

if (detectOverflow()) {
  // show read more
  displayReadMore();
}

domContentLoaded(() => {
  reactComponentManager({
    LoadMore,
    NBCTruncate,
  });
});

if (module.hot) {
  module.hot.accept();

  reactComponentManager({
    LoadMore,
    NBCTruncate,
  });
}
